import { Box, Button, Tooltip } from '@mui/material';
import { SquarePenIcon, ToggleLeftIcon, ToggleRightIcon } from 'lucide-react';
import { Statute } from '../../types/Statute.type';
import { ChargeEnhancement } from './EnhancementsDialog';
import EnhancementsPreview from './EnhancementsPreview';

interface EnhancementsButtonProps {
  caseCharges: Statute[];
  enhancementStatutes: Statute[];
  chargeEnhancements: ChargeEnhancement[];
  disabled: boolean;
  onOpen: () => void;
}

export default function EnhancementsButton({
  caseCharges,
  enhancementStatutes,
  chargeEnhancements,
  disabled,
  onOpen,
}: EnhancementsButtonProps) {
  const hasEnhancements = enhancementStatutes.length > 0 || chargeEnhancements.some((e) => e.enhancements.length > 0);

  const button = (
    <Button
      variant='outlined'
      fullWidth
      onClick={onOpen}
      disabled={disabled}
      sx={{
        paddingY: '13px',
        color: 'text.primary',
        borderColor: '#b6babe',
        borderRadius: 1,
        gap: 1,
        '&:hover': { borderColor: 'text.primary', backgroundColor: 'white' },
        '&.Mui-disabled': { borderColor: 'divider' },
        backgroundColor: hasEnhancements ? 'white' : 'transparent',
      }}
    >
      {hasEnhancements ? <ToggleRightIcon size={22} color='#25855A' /> : <ToggleLeftIcon size={22} />}
      <Box component='span' sx={{ flex: 1, textAlign: 'left' }}>
        Enhancements
      </Box>
      {hasEnhancements && <SquarePenIcon strokeWidth={2.2} size={16} style={{ color: '#20567E' }} />}
    </Button>
  );

  if (!hasEnhancements) return button;

  return (
    <Tooltip
      title={
        <EnhancementsPreview
          caseCharges={caseCharges}
          enhancementStatutes={enhancementStatutes}
          chargeEnhancements={chargeEnhancements}
          onOpen={onOpen}
        />
      }
      placement='right'
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            color: 'text.primary',
            boxShadow: 3,
            maxWidth: 340,
          },
        },
      }}
    >
      {button}
    </Tooltip>
  );
}
